(() => {
  const initialize = () => {
    document.querySelectorAll('[data-hm-purchase-shortcuts]').forEach(bar => {
      if (bar.dataset.ready || bar.closest('quick-add-modal')) return;
      const container = document.getElementById('ProductInfo-' + bar.dataset.sectionId);
      const source = container?.querySelector('product-form [name="add"]');
      if (!source) return;
      bar.dataset.ready = 'true';
      const help = bar.querySelector('[data-hm-fit-link]');
      const choose = bar.querySelector('[data-hm-options-link]');
      const fit = container.querySelector('[data-hm-fit-open]');
      if (!fit) help.hidden = true;
      help.addEventListener('click', event => {
        event.preventDefault();
        fit?.click();
      });
      choose.addEventListener('click', () => {
        if (!source.disabled) source.form.requestSubmit(source);
      });
      const sync = () => {
        choose.textContent = source.querySelector('span')?.textContent.trim() || source.textContent.trim();
        choose.disabled = source.disabled || source.getAttribute('aria-disabled') === 'true';
      };
      sync();
      new MutationObserver(sync).observe(source, { attributes: true, childList: true, subtree: true, characterData: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(entries => { bar.hidden = entries[0].isIntersecting; }).observe(source);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true }); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
